export default "__VITE_ASSET__DQ90E_ix__"